import React, { useEffect, useMemo, useState } from 'react';
import { Obra, ObrasAdapter } from '../../../../../infraestructure/persistence/rest/ObrasAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import moment from 'moment';
//import ComboObras from './combo';
//import { FIX_SOCIEDAD_MAESTRO_ADMUSUARIOS } from '../../../../../shared/constanst/constants';
import ComboObras from './combo';

export const ComboObrasContainer = (props: any) => {
  
  const api = new ObrasAdapter();
  const {idProyecto,disabled} = props;
  const { exceptionError, resultError } = useNotifications();
  let [obras, setObras] = useState<any>(undefined);
  let [selectedOptions, setSelectedOptions] = useState<any>(props.selectedOptions);
  let result: any;
  
  useEffect(()=>{
    if(!disabled){
      if(idProyecto){
        getObrasProyecto(idProyecto);
        setSelectedOptions([...[]])
      }else{
        props.dependency ? setObras([...[]]) : getObras()
      }
    }
  },[idProyecto])

  useEffect(()=>{setSelectedOptions(props.selectedOptions)},[props.selectedOptions]);

  const getObras = async()=>{
    try {
        result = await api.ListarObras();
        if(result.data && result.data!=="")
        {
            setObras([ ...result.data ]);
        }else{resultError()}
    } catch (error) {
        let exception = ServerErrorMessage(error);
        exceptionError(exception)
    }
  }

  const getObrasProyecto = async(idProyecto:number)=>{
    try {
        result = await api.ListarObrasProyecto(idProyecto);
        if(result.data && result.data!=="")
        {
            setObras([ ...result.data ]);
        }else{resultError()}
    } catch (error) {
        let exception = ServerErrorMessage(error);
        exceptionError(exception)
    }
  }

  return <ComboObras {...{...props,...{selectedOptions:selectedOptions}}} options={obras}/>
};

export default ComboObrasContainer;